(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-klaviyo-script"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-newsletter-klaviyo]').forEach(function (container) {
      var form = container.querySelector('[data-newsletter-form]');
      if (!form) return;

      var successMessage = container.querySelector('[data-newsletter-success-message]');
      var successText = container.querySelector('[data-newsletter-success-text]');
      var errorMessage = container.querySelector('[data-newsletter-error-message]');
      var submitButton = container.querySelector('[data-newsletter-submit]');
      var listId = container.dataset.listId;
      var companyId = (window.theme && window.theme.klaviyo && window.theme.klaviyo.company_id) || '';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var emailInput = form.querySelector('input[name="email"]');

        if (errorMessage) {
          errorMessage.hidden = true;
          errorMessage.textContent = '';
        }

        if (!emailInput || !emailInput.checkValidity()) {
          if (errorMessage) {
            errorMessage.textContent = container.dataset.invalidEmailText;
            errorMessage.hidden = false;
          }
          return;
        }

        if (!companyId) {
          if (errorMessage) {
            errorMessage.textContent = container.dataset.genericErrorText;
            errorMessage.hidden = false;
          }
          return;
        }

        var email = emailInput.value.trim();

        submitButton.disabled = true;
        submitButton.textContent = submitButton.dataset.processingText;

        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + companyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Klaviyo requires a fixed API revision; bump this if Klaviyo deprecates it.
            revision: '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId }
                }
              }
            }
          })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Klaviyo subscription failed');
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'newsletter_form_submitted' });

            form.hidden = true;
            if (successText) {
              successText.textContent = container.dataset.successText;
            }
            if (successMessage) {
              successMessage.hidden = false;
            }
          })
          .catch(function () {
            if (errorMessage) {
              errorMessage.textContent = container.dataset.genericErrorText;
              errorMessage.hidden = false;
            }
          })
          .finally(function () {
            submitButton.disabled = false;
            submitButton.textContent = submitButton.dataset.submitText;
          });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
